import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_FILE_TYPES_REQUEST: '',
  GET_FILE_TYPES_SUCCESS: '',
  GET_FILE_TYPES_FAILURE: '',

  GET_SERVER_REQUEST: '',
  GET_SERVER_SUCCESS: '',
  GET_SERVER_FAILURE: '',

  GET_COMPANIES_REQUEST: '',
  GET_COMPANIES_SUCCESS: '',
  GET_COMPANIES_FAILURE: '',
};

types = setStoreTypeValues(types, 'parameter');

export default types;
